import { render, staticRenderFns } from "./JobPost.vue?vue&type=template&id=22f706fa&scoped=true&"
import script from "./JobPost.vue?vue&type=script&lang=js&"
export * from "./JobPost.vue?vue&type=script&lang=js&"
import style0 from "./JobPost.vue?vue&type=style&index=0&id=22f706fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f706fa",
  null
  
)

export default component.exports